webpackJsonp([3],{

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(978),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(818), __esModule: true };

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(835);



var FIREBASE_CONFIG = {
  apiKey: "AIzaSyAN0IXHvhXGJ0Laahpn2Z32x3XxGh3pFKQ",
  authDomain: "car-dashboard-others.firebaseapp.com",
  databaseURL: "https://car-dashboard-others.firebaseio.com",
  projectId: "car-dashboard-others",
  storageBucket: "car-dashboard-others.appspot.com",
  messagingSenderId: "399290790798"
};

__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(FIREBASE_CONFIG);
var firestore = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();

// in the future, users will be able to edit their comments
// const auth = firebase.auth()
// const currentUser = auth.currentUser

// we will remove local storage soon and use offline persistence
// firestore.enablePersistence()
//   .then(function() {
//       // Initialize Cloud Firestore through firebase
//       var db = firestore;
//   })
//   .catch(function(err) {
//       if (err.code == 'failed-precondition') {
//           // Multiple tabs open, persistence can only be enabled
//           // in one tab at a a time.
//           // ...
//       } else if (err.code == 'unimplemented') {
//           // The current browser does not support all of the
//           // features required to enable persistence
//           // ...
//       }
//   });
var settings = { /* your settings... */timestampsInSnapshots: true };
firestore.settings(settings);

var db = firestore;

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

__webpack_require__(418);
var firebase = _interopDefault(__webpack_require__(25));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = firebase;


/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firestore__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_firestore__);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_on_firebaseConfig__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_timers__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'feedback_adminview',
  components: {},
  data: function data() {
    return {
      fullName: '',
      organization: '',
      comment: '',
      userComments: JSON.parse(this.$ls.get('user_comments')) || [],
      userType: this.$ls.get('user_type') || [],
      internetCheckURL: 'https://jsonplaceholder.typicode.com/todos/1',
      isComponentModalActive: false,
      sureDelete: false,
      userComment: {},
      deletedCommentsTimestamp: [],
      columns: [{
        field: 'fullName',
        label: 'Name',
        html: true
      }, {
        field: 'organization',
        label: 'Organization',
        html: true
      }, {
        field: 'comment',
        label: 'Comment',
        html: true
      }, {
        field: 'timestamp',
        label: 'Timestamp',
        hidden: true
      }, {
        field: 'action',
        label: 'Action',
        html: true
      }],
      rows: []
    };
  },

  methods: {
    fetchComments: function fetchComments() {
      var _this = this;

      var userComments = this.userComments.slice(0);
      this.$firestore.userComments.get().then(function (querySnapShot) {
        var tempComments = [];
        querySnapShot.forEach(function (doc) {
          // console.log(doc.id, doc.data());
          var data = {
            'id': doc.id,
            'fullName': doc.data().fullName,
            'organization': doc.data().organization,
            'comment': doc.data().comment,
            'timestamp': doc.data().timestamp,
            'deleted': doc.data().deleted
          };
          tempComments.push(data);
        });
        // sync local storage with firestore...
        userComments = _this.syncFirestoreToLocalstorage(tempComments, userComments);
        // update the localstorage with the latest comments from firestore.
        _this.$ls.set('user_comments', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(userComments));
        // sort the comments in the order they were made...
        _this.userComments = userComments.slice(0).sort(function (a, b) {
          return b.timestamp - a.timestamp;
        });
      }).catch(function (error) {
        console.log('cannot read from firestore', error);
      });
    },
    syncFirestoreToLocalstorage: function syncFirestoreToLocalstorage(tempComments, userComments) {
      var hasDocument = false;
      var commentsToSync = this.userComments.slice(0);
      for (var i = 0; i < tempComments.length; i++) {
        for (var j = 0; j < userComments.length; j++) {
          if (tempComments[i].timestamp === userComments[j].timestamp) {
            // document from firestore exists in local storage, skip
            hasDocument = true;
            break;
          }
        }
        // document from firestore doesn't exist and is not deleted, add
        if (!hasDocument && !tempComments[i].deleted) {
          commentsToSync.push(tempComments[i]);
        }
        // reset hasDocument.
        hasDocument = false;
      }
      return commentsToSync.slice(0);
    },
    loadCommentTable: function loadCommentTable() {
      var _this2 = this;

      this.rows = [];
      var tableRowProp = {};
      var userComments = this.userComments.slice(0);
      userComments.sort(function (a, b) {
        return b.timestamp - a.timestamp;
      });
      userComments.map(function (elem, idx) {
        tableRowProp.fullName = elem.fullName;
        tableRowProp.organization = elem.organization;
        tableRowProp.comment = elem.comment;
        tableRowProp.timestamp = elem.timestamp;
        _this2.rows.push(tableRowProp);
        tableRowProp = {};
      });
      tableRowProp = {};
    },
    rowStyleClassFn: function rowStyleClassFn(row) {
      return row.originalIndex % 2 === 0 ? 'gray' : 'silver';
    },

    // load a single comment from the comments table
    loadComment: function loadComment(row, e) {
      var _this3 = this;

      // console.log(row, e);
      this.userComments.map(function (elem, idx) {
        if (elem.timestamp === row.timestamp) {
          _this3.userComment = elem;
        }
      });
      this.isComponentModalActive = !this.isComponentModalActive;
    },
    removeComment: function removeComment(timestamp) {
      var _this4 = this;

      // alert the user he's deleted an item
      alert('One comment deleted');
      //set timeout to remove the comment modal and reset sure delete variable
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_timers__["setTimeout"])(function () {
        _this4.isComponentModalActive = !_this4.isComponentModalActive;
        _this4.sureDelete = !_this4.sureDelete;
      }, 1000);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_timers__["setTimeout"])(function () {
        // filter through the usercomments to get the deleted comment
        var userComments = _this4.userComments.slice(0).filter(function (elem, idx, arr) {
          return elem.timestamp !== timestamp;
        });
        // reset usercomments
        _this4.userComments = userComments;
        // update user_comments in local storage.
        _this4.$ls.set('user_comments', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(userComments));
        var deletedCommentsTimestamp = JSON.parse(_this4.$ls.get('deleted_comments'));
        if (!deletedCommentsTimestamp) {
          deletedCommentsTimestamp = [];
        }
        // we track deleted comments using their timestamps
        deletedCommentsTimestamp.push(timestamp);
        _this4.$ls.set('deleted_comments', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(deletedCommentsTimestamp));
        _this4.deletedCommentsTimestamp = deletedCommentsTimestamp;
      }, 1200);
    },
    checkDeletedComments: function checkDeletedComments(firebaseComments) {
      var deletedCommentsTimestamp = this.deletedCommentsTimestamp.slice(0);
      var commentsToDelete = [];
      for (var i = 0; i < deletedCommentsTimestamp.length; i++) {
        for (var j = 0; j < firebaseComments.length; j++) {
          // console.log(deletedCommentsTimestamp[i].timestamp, firebaseComments[j].timestamp);
          if (deletedCommentsTimestamp[i] === firebaseComments[j].timestamp) {
            commentsToDelete.push(firebaseComments[i]);
            break;
          }
        }
      }
      return commentsToDelete;
    }
  },
  firestore: function firestore() {
    return {
      userComments: __WEBPACK_IMPORTED_MODULE_3__assets_js_on_firebaseConfig__["a" /* db */].collection('user_comments')
    };
  },
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var userComments;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // load all comments from local storage...
              userComments = JSON.parse(_this5.$ls.get('user_comments')) || [];

              _this5.userComments = userComments.slice(0).sort(function (a, b) {
                return b.timestamp - a.timestamp;
              });

              _context.next = 4;
              return _this5.axios.get(_this5.internetCheckURL).then(function (result) {
                // get comments from firestore and save to local storage
                _this5.fetchComments(); // fetch synchronized comments...
              }).catch(function (error) {
                console.log('No internet available, cant fetch from firestore: ', error);
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  },
  mounted: function mounted() {

    // this.loadCommentTable();
  },

  watch: {
    deletedCommentsTimestamp: function deletedCommentsTimestamp(val) {
      var _this6 = this;

      this.axios.get(this.internetCheckURL).then(function (result) {
        _this6.$firestore.userComments.get().then(function (querySnapShot) {
          var tempComments = [];
          querySnapShot.forEach(function (doc) {
            // console.log(doc.id, doc.data());
            var data = {
              'id': doc.id,
              'fullName': doc.data().fullName,
              'organization': doc.data().organization,
              'comment': doc.data().comment,
              'timestamp': doc.data().timestamp,
              'deleted': doc.data().deleted
            };
            tempComments.push(data);
          });
          // get the comments to delete on firestore
          var commentsToDelete = _this6.checkDeletedComments(tempComments);
          console.log(commentsToDelete);
          commentsToDelete.map(function (elem, idx) {
            _this6.$firestore.userComments.doc(elem.id).update({
              // to delete is to set deleted field as true.
              // timestamp: (new Date()).getTime(),
              deleted: true
            }).then(function (result) {
              console.log("Document successfully deleted!");
            }).catch(function (error) {
              console.error("Error removing document: ", error);
            });
          });
        }).catch(function (error) {
          console.error('cannot read from firestore', error);
        });
      }).catch(function (error) {
        console.error('No internet connection, can\'t delete on firestore');
      });
    },
    userComments: function userComments() {
      this.loadCommentTable();
    }
  }
});

/***/ }),

/***/ 978:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "is-fullhd"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-8"
  }, [_c('vue-good-table', {
    staticClass: "table table-responsive",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "lineNumbers": true,
      "fixed-header": false,
      "search-options": {
        enabled: false,
      },
      "paginationOptions": {
        enabled: true,
        mode: 'pages',
        perPageDropdown: [5, 8, 10, 15, 25]
      },
      "rowStyleClass": _vm.rowStyleClassFn,
      "styleClass": "vgt-table table table-bordered table-striped comments_table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'action') ? _c('span', [_c('v-btn', {
          attrs: {
            "ripple": false
          },
          on: {
            "click": function($event) {
              _vm.loadComment(props.row, $event)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "blue"
          }
        }, [_vm._v("visibility")])], 1)], 1) : _c('span', {
          staticStyle: {
            "font-family": "Roboto",
            "font-size": "18px"
          }
        }, [_vm._v("\n              " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }, {
      key: "table-column",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "font-family": "Roboto",
            "font-size": "20px",
            "color": "#1E70EC"
          }
        }, [_vm._v("\n                " + _vm._s(props.column.label) + "\n            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('span', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.png"
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-12"
  })]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('form', {
    staticStyle: {
      "font-family": "Roboto"
    },
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head bg-primary"
  }, [_c('span', {
    staticClass: "modal-card-title",
    staticStyle: {
      "color": "white"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userComment.fullName))])])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('blockquote', [_vm._v("\n                    " + _vm._s(_vm.userComment.comment) + "\n                    "), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.userComment.organization))])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot pull-right"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = false
      }
    }
  }, [_vm._v("CLOSE")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType === 'superadmin'),
      expression: "userType === 'superadmin'"
    }]
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.sureDelete = !_vm.sureDelete
      }
    }
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sureDelete),
      expression: "sureDelete"
    }],
    staticClass: "button is-warning",
    on: {
      "click": function($event) {
        _vm.removeComment(_vm.userComment.timestamp)
      }
    }
  }, [_vm._v("Click to confirm DELETE")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userType === 'admin'),
      expression: "userType === 'admin'"
    }]
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('You dont have the permission to delete a comment'),
      expression: "'You dont have the permission to delete a comment'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "button is-primary",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("DELETE")])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "margin": "10px 10px"
    }
  }, [_c('span', {
    staticClass: "column is-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "column is-8"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "font-family": "'Open Sans', Roboto, sans-serif",
      "font-size": "16px",
      "color": "blue"
    }
  }, [_vm._v("\n              These are comments made by the users of the dashboard from different locations world over.\n              Comments are saved on the user browser, and syncs with the to the cloud when there's internet\n              Note that only superadmin users can delete unuseful comments.\n            ")])])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.4e226fa7afd9f97308cb.js